import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'core-message-details-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './message-details-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDetailsSkeletonCoreComponent {
  tabCount = input<number>(2);
}
